import React from 'react';
import CustomerColor from 'components/Tvendo/Setting/CustomerColor/List.js';

export default function () {
  return <CustomerColor />;
}
